import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @format */

import React, { Component } from 'react';
import styled from 'styled-components';
import { colours, zIndexes } from "../../constants/css";
import CloseBtn from "./CloseBtn";
export var ModalWrapper = styled.div.withConfig({
  displayName: "Modal__ModalWrapper",
  componentId: "sc-4w0crc-0"
})(["display:", ";position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,0.7);z-index:", ";overflow:auto;"], function (props) {
  return props.show ? 'block' : 'none';
}, function (props) {
  return props.zIndex;
});
export var ModalBody = styled.div.withConfig({
  displayName: "Modal__ModalBody",
  componentId: "sc-4w0crc-1"
})(["position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);max-width:", ";min-height:", ";width:95%;background:", ";border-radius:0.5rem;"], function (props) {
  return "".concat(props.width, "px");
}, function (props) {
  return "".concat(props.height, "px");
}, colours.qantasWhite);
var Modal = /*#__PURE__*/function (_Component) {
  function Modal() {
    var _this;
    _classCallCheck(this, Modal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, Modal, [].concat(args)), _this.handleOutsideClick = function (e) {
      if (_this.modalWrapper.contains(e.target) && !_this.modalBody.contains(e.target)) {
        _this.props.onClose();
      }
    }, _assertThisInitialized(_this)));
  }
  _inherits(Modal, _Component);
  return _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        show = _this$props.show,
        children = _this$props.children,
        onClose = _this$props.onClose,
        width = _this$props.width,
        height = _this$props.height,
        zIndex = _this$props.zIndex;
      return __jsx(ModalWrapper, {
        ref: function ref(el) {
          _this2.modalWrapper = el;
        },
        show: show,
        zIndex: zIndex
      }, __jsx(ModalBody, {
        ref: function ref(el) {
          _this2.modalBody = el;
        },
        width: width,
        height: height
      }, __jsx(CloseBtn, {
        onClose: onClose
      }), children));
    }
  }]);
}(Component);
Modal.defaultProps = {
  width: 550,
  height: 0,
  zIndex: zIndexes.modal
};
export default Modal;